import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Text from '@jetbrains/ring-ui/components/text/text';
import { ConstituentDisabledWidget } from '@modules/constituents/widget/constituent-disabled-widget';
import { getConstituentDialogFirstStep } from '@modules/constituents/constituent-dialog/constituent-dialog-steps';
import { useModalsController } from '@common/modals/hooks';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import NavigationLink from '@common/navigation/navigation-link';
import { ExternalLinks } from '@common/constants/constants';
import { AiEnableDialog } from '../../../common/dialogs/ai-settings-dialog/ai-enable-dialog';
export function AiJbaNotEnabledWidget(props) {
    const { licenseType, constituentLicense } = props;
    const modalsController = useModalsController();
    const handleOpenModal = useCallback(async () => {
        const openEnableModal = modalsController.openModal(AiEnableDialog, {
            startFromStep: getConstituentDialogFirstStep(constituentLicense, licenseType)
        });
        openEnableModal.promise.then(() => {
            openEnableModal.closeModal();
        });
    }, [constituentLicense, licenseType, modalsController]);
    return (_jsx(ConstituentDisabledWidget, { ...props, ...assignTestId('widget-ai-enterprise'), onEnableClick: handleOpenModal, canEnable: false, children: _jsxs(Text, { children: ["To start using AI Enterprise, enable JetBrains AI through", ' ', _jsx(NavigationLink, { target: "_blank", href: ExternalLinks.JB_ACCOUNT, children: "JetBrains Account" })] }) }));
}
